import React from "react";
import { List, Button } from "semantic-ui-react";
import { extractCustom, isUrl } from "./helpers";
import { TABLE_FORMAT_REGEX } from "../constants/CustomFields";
import TableCustomFieldModal from "./TableCustomFieldModal";

const CustomItems = ({ items, useHeaders = false, noEmptyLabel = false }) => {
  let custom = extractCustom(items);
  custom = custom.filter(elem => elem["key"] !== "description");

  // Helper function to check if a value is a table custom field
  const isTableFormat = value => {
    return typeof value === "string" && TABLE_FORMAT_REGEX.test(value);
  };

  // Helper function to render field value based on type
  const renderFieldValue = field => {
    if (isUrl(field.value)) {
      return (
        <a href={field.value} target="_blank" rel="noopener noreferrer">
          {field.value}
        </a>
      );
    } else if (Array.isArray(field.value)) {
      return field.value.join(", ");
    } else if (isTableFormat(field.value)) {
      // Table custom field - wrap in modal with external icon
      return (
        <TableCustomFieldModal
          fieldName={field.key}
          fieldValue={field.value}
          trigger={
            <span
              style={{
                cursor: "pointer",
                display: "inline-flex",
              }}
            >
              {field.value}
              <Button size="small" basic icon="external" />
            </span>
          }
        />
      );
    } else {
      return field.value;
    }
  };

  if (custom.length === 0) {
    return noEmptyLabel ? null : "None";
  }

  return custom.map((field, index) => (
    <List.Item key={index} style={{ wordWrap: "break-word" }}>
      {useHeaders ? <List.Header>{field.key}:</List.Header> : `${field.key}:`}
      {renderFieldValue(field)}
    </List.Item>
  ));
};

export default CustomItems;
